import { render, staticRenderFns } from "./TramiteObservacao.vue?vue&type=template&id=3abe6842&scoped=true"
import script from "./TramiteObservacao.vue?vue&type=script&lang=js"
export * from "./TramiteObservacao.vue?vue&type=script&lang=js"
import style0 from "./TramiteObservacao.vue?vue&type=style&index=0&id=3abe6842&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3abe6842",
  null
  
)

export default component.exports